export const chartObj = [
     { title : "Environmental Social and Governance", field : [ "Flash Point", "Sulfur" ] },
     { title : "Commercial", field : [ "Density @ 15°C", "Water Content", "Viscosity @ 50°C", "Viscosity @ 40°C", "NSE" ] },
     { title : "Cold-Flow", field : [ "Pour Point", "Cold Filter Plugging Point", "Wax Appearance Temperature", "Wax Disappearance Temperature", "Cloud Point" ] },
     { title : "Asset Protection - HSFO/VLSFO", field : [ "Ash", "Micro Carbon Residue", "Acidity", "Total Sediment Potential", "Calcium", "Phosphorus", "Zinc", "Vanadium", "Sodium", "Ctafines" ] },
     { title : "Asset Protection - Distillates", field : [ "Acidity1", "Lubricity", "Micro Carbon Residue1", "Ash1", "Fame" ] }
]

export const testparams = {
     'Flash Point': false, 'Sulfur': false, 'Density @ 15°C': false,
     'Water Content': false, 'Viscosity @ 50°C': false, 'Viscosity @ 40°C': false,
     'Pour Point': false, 'Cold Filter Plugging Point': false,
     'Wax Appearance Temperature': false, 'Wax Disappearance Temperature': false,
     'Cloud Point': false, 'Ash': false, 'Micro Carbon Residue': false, 'Micro Carbon Residue1': false,
     'Acidity': false, 'Total Sediment Potential': false, 'Calcium': false,
     'Phosphorus': false, 'Zinc': false, 'Vanadium': false, 'Sodium': false,
     'Ctafines': false, 'Acidity1': false, 'Lubricity': false, 'Ash1': false, 'Fame': false, 'NSE': false,
}

export const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",];

export const fieldName=(item)=>{
     return(
          item === "Sulfur"?"Sulphur":
          item === "Wax Disappearance Temperature"?"WDT (VLSFO/HFO)":
          item === "Cold Filter Plugging Point"?"CFPP (Distillates)":
          item === "Wax Appearance Temperature"?"WAT (VLSFO/HFO)":
          item === "Cloud Point"?"Cloud Point (Distillates)":
          item === "Micro Carbon Residue"?"MCR":
          item === "Micro Carbon Residue1"?"MCR":
          item === "Ash1"?"Ash":
          item === "Acidity1"?"Acidity":
          item === "Total Sediment Potential"?"TSP":
          item === "Calcium"?"Calcium (ULO)":
          item === "Zinc"?"Zinc (ULO)":
          item === "Phosphorus"?"Phosphorus (ULO)":
          item === "Ctafines"?"Catfines (Al+Si)":item
     )
}

export const paramNames = (item) => {
     return(
          item === "Micro Carbon Residue1"?"Micro Carbon Residue":
          item === "Ash1"?"Ash":
          item === "Acidity1"?"Acidity":item
     )
}